/**
 * Extrai o "Pedido na Loja" das observações do Bling e detecta o marketplace.
 * Retorna { code, marketplace } — marketplace é "Shopee" | "Mercado Livre" | "Magazine Luiza" | "Amazon" | "Americanas" | "Shein" | null.
 *
 * Prioriza `order.marketplace_source` (derivado do CNPJ do intermediador no Bling,
 * mais confiável). Se ausente, cai no parser de texto das observações.
 */
export function parsePedidoNaLoja(order) {
  const source = order?.marketplace_source || null;
  const storeNumber = (order?.store_number || "").trim();

  if (source) {
    return { code: storeNumber || null, marketplace: source };
  }

  // Fallback: parser textual das observações do Bling
  const text = [order?.observations, order?.internal_observations].filter(Boolean).join(" \n ");
  if (!text) return { code: storeNumber || null, marketplace: null };
  const match = text.match(/Pedido(?:\s+na)?\s+Loja\s*:\s*([^\s\n\r,;|]+)/i);
  if (!match) return { code: storeNumber || null, marketplace: null };
  const code = match[1].trim();
  if (!code) return { code: storeNumber || null, marketplace: null };
  const isOnlyDigits = /^\d+$/.test(code);
  const marketplace = isOnlyDigits ? "Mercado Livre" : "Shopee";
  return { code, marketplace };
}

/**
 * Retorna { bg, fg } com as cores da marca do marketplace, para renderizar badges.
 */
export function marketplaceBadgeColors(marketplace) {
  switch (marketplace) {
    case "Shopee":         return { bg: "#EE4D2D", fg: "#FFFFFF" };
    case "Mercado Livre":  return { bg: "#FFE600", fg: "#000000" };
    case "Magazine Luiza": return { bg: "#0086FF", fg: "#FFFFFF" };
    case "Amazon":         return { bg: "#FF9900", fg: "#000000" };
    case "Americanas":     return { bg: "#E60014", fg: "#FFFFFF" };
    case "Shein":          return { bg: "#000000", fg: "#FFFFFF" };
    default:               return { bg: "#3F3F46", fg: "#FFFFFF" };
  }
}

/**
 * Formata data ISO YYYY-MM-DD para dd/mm/yyyy em pt-BR. Retorna "—" se vazio.
 */
export function orderSkus(order) {
  const skus = [];
  for (const it of order?.order_items || []) {
    const s = (it.sku || "").trim();
    if (s && !skus.includes(s)) skus.push(s);
  }
  return skus;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const s = String(iso).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return "—";
  const [y, m, d] = s.split("-");
  return `${d}/${m}/${y}`;
}

export function emptyOrdersMessage(showDeleted, marketplaceFilter) {
  if (showDeleted) return "Nenhum pedido excluído. Pedidos excluídos da lista aparecem aqui e podem ser restaurados.";
  if (marketplaceFilter !== "all") return "Nenhum pedido do marketplace selecionado nesta página. Ajuste o filtro ou avance a paginação.";
  return "Conecte o Bling para importar pedidos ou crie um pedido manual.";
}
